module.exports = __webpack_public_path__ + "static/img/eec-group7.8c9876f1.png";